import React, { useState, useEffect } from "react";

import { Container, Row, Col, Form } from "react-bootstrap";
import api from "../../../api";
import ButtonLoader from "components/Common/ButtonLoader";
import { Link, useHistory } from "react-router-dom";
import {
  CreateCityRecord,
  FetchCityById,
  FetchRegionList,
  FetchStateList,
  UpdateCityRecord,
} from "../../../services/locationService";
import arrow_btn from "../../../assets/images/icon/arrow-btn.svg";
import { toast } from "react-toastify";
import { checkPermissionStatus } from "helpers/utils";
import { decryptDataFromArray, encryptDataToArray } from "helpers/EncDec";
import { GetCompanyData } from "services/CompanyService";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
const EditCity = props => {
  const { t } = useTranslation();
  const history = useHistory();
  const { cityId } = useParams();
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [Country, setCountry] = useState([]);
  const [Region, setRegion] = useState([]);
  const [State, setState] = useState([]);
  const [statePayload, setStatePayload] = useState({
    status: "1",
  });
  const [countryId, setCountryId] = useState(null);

  const [countryIdSelected, setCountryIdSelected] = useState(false);
  const handleInput = event => {
    const { name, value } = event.target;

    setStatePayload(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCountrySelection = CountryID => {
    setStatePayload(prevState => ({
      ...prevState,
      country_id: CountryID,
      region_id: null,
      state_id: null,
    }));
    setCountryId(CountryID);
  };
  const handleRegionSelection = RegionID => {
    const selectedRegionId = RegionID || "";
    setStatePayload(prevState => ({
      ...prevState,
      region_id: selectedRegionId,
      state_id: null,
    }));
  };
  const handleStateSelection = StateID => {
    setStatePayload(prevState => ({
      ...prevState,
      state_id: StateID,
    }));
  };

  const EditCity = payload => {
    UpdateCityRecord(payload, cityId)
      .then(response => {
        setIsLoading(false);
        toast.success(t(`Location_Manager.City updated`));
        history.push("/city-list");
      })
      .catch(err => {
        setIsLoading(false);

        let msg =
          err?.response?.data?.message ||
          err?.message ||
          t(`Location_Manager.Edit city err`);
        toast.error(msg);

        if (Object.keys(err?.response?.data?.message?.errors || {})?.length) {
          setErrors(err?.response?.data?.message?.errors || {});
        }
      });
  };

  const handleSubmit = event => {
    event.preventDefault();
    setErrors({});
    setIsLoading(true);
    let errorObj = {};

    if (!statePayload?.country_id) {
      errorObj["country_id"] = t(`Location_Manager.Country required`);
    }

    // if (!statePayload?.region_id) {
    //   errorObj["region_id"] = "Region is required";
    // }

    if (!statePayload?.state_id) {
      errorObj["state_id"] = t(`Location_Manager.State required`);
    }

    if (!statePayload?.city) {
      errorObj["city"] = t(`Location_Manager.City required`);
    }

    if (Object.keys(errorObj)?.length > 0) {
      setIsLoading(false);
      setErrors(prevState => ({
        ...prevState,
        ...errorObj,
      }));

      return;
    }

    let reqData = {
      country_id: statePayload?.country_id || countryId,
      region_id: statePayload?.region_id,
      state_id: statePayload?.state_id,
      city: statePayload?.city,
      status: statePayload?.status,
    };
    let encryptedQuery = encryptDataToArray(reqData);

    let payload = new FormData();
    payload.append("reqData", JSON.stringify(encryptedQuery));

    EditCity(payload);
  };

  const fetchCountryData = () => {
    api
      .get(`${process.env.REACT_APP_API_URL}/admin/location/country-list`)
      .then(response => {
        const { success, allCountry } = response.data;
        if (success) {
          const { allCountry } = response.data;
          let data = allCountry?.map(item => ({
            id: item?.id,
            label: item?.name,
            value: item?.name,
          }));
          setCountry(data);
        }
      })
      .catch(err => console.log("Error:::", err));
  };
  const fetchRegionData = () => {
    FetchRegionList()
      .then(res => {
        let response = decryptDataFromArray(res?.data);
        const allRegion = response?.data?.filter(item => item.status === 1) || [];
        let data = allRegion?.map(item => ({
          id: item?.id,
          label: item?.region,
          value: item?.region,
          country_id: item?.country_id,
        }));
        setRegion(data);
      })
      .catch(err => console.log("Error:::", err));
  };
  const fetchStateData = () => {
    FetchStateList()
      .then(res => {
        let response = decryptDataFromArray(res?.data);
        const allState = response?.data?.filter(item => item.status === 1) || [];
        let data = allState?.map(item => ({
          id: item?.id,
          label: item?.name,
          value: item?.name,
          country_id: item?.country_id,
          region_id: item?.region_id,
        }));
        setState(data);
      })
      .catch(err => console.log("Error:::", err));
  };

  const GetCity = () => {
    FetchCityById(cityId)
      .then(res => {
        let stateData = res?.data?.data || {};
        // stateData = decryptDataFromArray(stateData);
        setStatePayload(stateData);
        setCountryId(stateData?.country_id);
        setCountryIdSelected(true);
      })
      .catch(err => {});
  };

  useEffect(() => {
    fetchCountryData();
    fetchRegionData();
    fetchStateData();
    GetCity();
  }, []);

  
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
if (!checkPermissionStatus("city-list", "create")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`Location_Manager.Access Denied`)}</h4>
      </div>
    );
  }
  return (
    <div className="page-content">
      <Container fluid>
        <div className="joblist-container create-vacancy">
          <Row className="mb-3 align-items-center depart-content">
            <Col lg="6" md="6">
              <Link to="/city-list">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  {t(`Location_Manager.Edit City`)}
                </h5>
              </Link>
            </Col>
          </Row>
        </div>

        <div className="outerTab-box-wrapper below-vacancy">
          <div className="form-details-section mt-4">
            <Row>
              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.Country`)}
                  <span className="text-danger">*</span>
                </Form.Label>

                <select
                  type="select"
                  name="country_id"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  onChange={e => handleCountrySelection(e.target?.value)}
                  value={Country.find(option => option?.id == countryId)?.id}
                  disabled={countryIdSelected === true}
                  title={
                    Country.find(option => option?.id == countryId)?.label ||
                    `${t(`Location_Manager.Country`).toLowerCase()}`
                  }
                >
                  <option value="" selected>
                    {t(`Location_Manager.Select Country`)}
                  </option>
                  {Country &&
                    Country.map(el => {
                      return (
                        <option key={el?.value} value={el?.id}>
                          {el?.label}
                        </option>
                      );
                    })}
                </select>
                {errors?.country_id && (
                  <small className="text-danger"> {errors?.country_id} </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.Region`)}
                  {/* <span className="text-danger">*</span> */}
                </Form.Label>

                <select
                  type="select"
                  name="region_id"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  value={statePayload.region_id}
                  onChange={e => handleRegionSelection(e.target?.value)}
                  title={
                    Region.find(option => option?.id == statePayload?.region_id)?.label ||
                    `${t(`Location_Manager.Region`).toLowerCase()}`
                  }
                >
                  <option value="" selected>
                    {t(`Location_Manager.Select Region`)}
                  </option>
                  {Region &&
                    Region?.filter(reg => reg?.country_id == countryId)?.map(
                      el => {
                        return (
                          <option key={el?.value} value={el?.id}>
                            {el?.label}
                          </option>
                        );
                      }
                    )}
                </select>
                {/* {errors?.region_id && (
                  <small className="text-danger"> {errors?.region_id} </small>
                )} */}
              </Form.Group>
              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.Select State`)}
                  <span className="text-danger">*</span>
                </Form.Label>

                <select
                  type="select"
                  name="state_id"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  value={statePayload.state_id}
                  onChange={e => handleStateSelection(e.target?.value)}
                  onMouseEnter={e => {
                    e.target.setAttribute(
                      "title",
                      e.target.options[e.target.selectedIndex].text
                    );
                  }}
                >
                  <option value="" selected>
                    {t(`Location_Manager.Select State`)}
                  </option>
                  {State &&
                    State?.filter(st => {
                      let flag = false;
                      if (countryId && !statePayload?.region_id) {
                        flag = st?.country_id == countryId;
                      } else if (countryId && statePayload?.region_id) {
                        flag =
                          st?.country_id == countryId &&
                          st?.region_id == statePayload?.region_id;
                      }

                      return flag;
                    }).map(el => {
                      return (
                        <option key={el?.value} value={el?.id}>
                          {el?.label}
                        </option>
                      );
                    })}
                </select>
                {errors?.state_id && (
                  <small className="text-danger"> {errors?.state_id} </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label" htmlFor="city-input">
                  {t(`Location_Manager.City Name`)}
                  <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  id="city-input" // Unique ID to match the htmlFor attribute in the label
                  type="text"
                  placeholder={t(`Location_Manager.City`)}
                  name="city"
                  value={statePayload?.city}
                  onChange={handleInput}
                />
                {errors?.city && (
                  <small className="text-danger"> {errors?.city} </small>
                )}
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Location_Manager.Status`)}
                  <span className="text-danger">*</span>
                </Form.Label>
                <select
                  type="select"
                  name="status"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  onChange={handleInput}
                  value={statePayload?.status}
                  title={
                    document.querySelector('select[name="status"]')
                      ?.selectedOptions[0]?.text ||
                    `${t("Location_Manager.Status").toLowerCase()}`
                  }
                  onMouseOver={e =>
                    e.target.setAttribute(
                      "title",
                      e.target.selectedOptions[0].text
                    )
                  }
                >
                  <option value="1">{t(`Location_Manager.Active`)}</option>
                  <option value="0">{t(`Location_Manager.Inactive`)}</option>
                </select>
              </Form.Group>
            </Row>

            <Form.Group className="cta text-center d-flex gap-3 justify-content-left mt-4 pb-2">
              <Link to="/city-list" className="btn btn-secondary">
                {t(`Location_Manager.Cancel`)}
              </Link>
              <ButtonLoader
                title={t(`Location_Manager.Save Details`)}
                variant="primary"
                type="submit"
                loading={isLoading}
                message={t(`Location_Manager.Saving`)}
                onClick={e => {
                  handleSubmit(e);
                }}
              />
            </Form.Group>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default EditCity;
